import type { IListingRating, IReservation, IUser } from '@curbnturf/objects';
import { generateReservationConfirmationCode } from './reservation';

export const generateRatingPrivateNote = function (rating: IListingRating): string {
  if (!rating?.reservation) {
    return '';
  }

  return `For rating ${generateReservationConfirmationCode(rating.reservation)}`;
};

export const generateReservationPrivateNote = function (reservation: IReservation): string {
  return `Rent for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateReservationChangeIncreasePrivateNote = function (reservation: IReservation): string {
  return `Rent increase for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateReservationRefundDeductionPrivateNote = function (reservation: IReservation): string {
  return `Refund deduction for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateReferralPrivateNote = function (reservation: IReservation): string {
  return `Referral credit for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateBoondockDonationPrivateNote = function (donation: {
  user: IUser;
  boondockName: string;
  boondockId: number;
  price: number;
}): string {
  return `Boondocking donation for: ${donation.boondockName}(${donation.boondockId})`;
};

export const generatePoiDonationPrivateNote = function (donation: {
  user: IUser;
  poiName: string;
  poiId: number;
  price: number;
}): string {
  return `Point of Interest donation for: ${donation.poiName || 'Unnamed'}(${donation.poiId})`;
};

export const generateReservationCntPayment = function (reservation: IReservation): string {
  return `CNT Cash used for a reservation: ${generateReservationPrivateNote(reservation)}`;
};

export const generateDonationCntPayment = function (purchaseId: string): string {
  return `CNT Cash used for a donation: ${purchaseId}`;
};

/** A price-increase change spends CNT Cash under its own note — `private_note` is unique, and the
 *  original booking (or an earlier change) may already have used the plain reservation note. */
export const generateReservationChangeCntPayment = function (reservation: IReservation): string {
  return `CNT Cash used for a reservation change: ${generateReservationPrivateNote(reservation)} (${Date.now()})`;
};
